
export const GeneralReportConstant = {
    Table: {
        REPORT_TYPE: "Report",
        PRINTER: "Printer",
        FILE_LOCATION: "File Location",
        COMPANY_CODE: "Company Code",
        COMPANY_CODE_FROM: "Company Code (From)",
        COMPANY_CODE_TO: "Company Code (To)",
        CHARGE_ON_COMPANY: "Charge-on Company",
        CUSTOMER_CODE: "Customer Code",
        MASTER_COMPANY_CODE: "Master Company Code",
        ACTIVE_IND: "Active Ind.",
        DOC_DATE_FROM: "Doc Date (From)",
        DOC_DATE_TO: "Doc Date (To)",
        DOC_NO_FROM: "Doc No. (From)",
        DOC_NO_TO: "Doc No. (To)",
        PROPOSAL_NO: "Proposal No.",
        OPS_DATE_FROM: "Ops Date (From)",
        OPS_DATE_TO: "Ops Date (To)",
        GL_DATE_FROM: "GL Date (From)",
        GL_DATE_TO: "GL Date (To)",
        EXPORT_TYPE: "Export Type",
        EXPIRY_DATE_FROM: "Expiry Date (From)",
        EXPIRY_DATE_TO: "Expiry Date (To)",
        EFFECTIVE_DATE_FROM: "Effective Date (From)",
        EFFECTIVE_DATE_TO: "Effective Date (To)",
        CRITERIA_TYPE: "Criteria Type",
        CRITERIA_NAME: "Criteria Name",
        YEAR: "Year",
        FROM_YEAR: "From Year",
        TO_YEAR: "To Year",
        FROM_MONTH: "From Month",
        TO_MONTH: "To Month",
        MONTH: "Month",
        BILLING_CLERK: "Billing Clerk",
        EXCEPTION_DATE_FROM: "Exception Date/Time (From)",
        EXCEPTION_DATE_TO: "Exception Date/Time (To)",
        EXCEPTION_TYPE: "Exception Type",
        EDI_VIEW: "EDI View",
        CHARGE_TYPE: "Charge Type",
        PROPOSAL_TYPE: "Proposal Type",
        PROPOSAL_FROM: "Proposal (From)",
        PROPOSAL_TO: "Proposal (To)",
        PROPOSAL_STATUS: "Proposal Status",
        STANDARD: "Standard",
        GN: "GN",
        BOTH: "Both",
        VERSION: "Version",
        NORMAL: "Normal",
        DIFFERENCE: "Difference",
        TARIFF_NATURE: "Tariff Nature",
        TARIFF_TYPE: "Tariff Type",
        VESSEL_ARRIVAL_FROM: "Vessel Arrival From Date",
        VESSEL_ARRIVAL_TO: "Vessel Arrival To Date",
        THC: "THC",
        SHIPMENT_TYPE: "Shipment Type",
        CONTAINER_SIZE: "Container Size",
        CONTAINER_STATUS: "Container Status",
        CONSORTIUM_CODE: "Consortium Code",
        VESSEL_CODE: "Vessel Code",
        VOYAGE_CODE: "Voyage Code",
        CONSORTIUM: "Consortium",
        VESSEL: "Vessel",
        VOYAGE: "Voyage",
        TYPE: "Type",
        OPS_LINE_FROM: "Ops Line (From)",
        OPS_LINE_TO: "Ops Line (To)",
        BILL_TO_COMPANY: "Bill-To Company",
        COMPANY_TYPE: "Company Type",
        COMPANY_NAME: "Company Name",
        NTN_NO: "NTN No",
        AMOUNT: "Amount",
        TRANSACTION_TYPE: "Transaction Type",
        TRANSACTION_DATE_FROM: "Transaction Date From",
        TRANSACTION_DATE_TO: "Transaction Date To",
        DEPOSIT_AMOUNT: "Deposit Amount",
        USER_ID: "User ID",
        SHIPPER_CONSIGNEE: "Shipper/Consignee",
        SHIPPER_CONSIGNEE_COMPNY_NAME: "Shipper/Consignee Company Name",
        SUB_TYPE: "Sub Type",
        DOC_TYPE: "Doc Type",
        CREDIT: "Credit",
        ADJUSTMENT: "Adjustment",
        MASTER_CHARGE_ON_COMPANY: "Master Charge-on Company",
        OPERATING_TML: "Operating Tml",
        SERVICE_CODE: "Service Code",
        REFERENCE_DATE_FROM: "Reference Date (From)",
        REFERENCE_DATE_TO: "Reference Date (To)",
        APPROVED_DATE_FROM: "Approved Date Time From",
        APPROVED_DATE_TO: "Approved Date Time To",
        DATE_FROM: "Date (From)",
        DATE_TO: "Date (To)",
        OPS_DATE: "Ops Date",
        VIEW: "View",
        SETTLEMENT_DATE_FROM: "Settlement Date (From)",
        SETTLEMENT_DATE_TO: "Settlement Date (To)",
        COLL_DATE_FROM: "Collection Date (From)",
        COLL_DATE_TO: "Collection Date (To)",
        CASHIER_ID: "Cashier Id",
        OPS_LINE: "Ops Line",
        SHIPPING_LINE: "Shipping Line",
        TARIFF_CODE: "Tariff Code"
    },
    Title: {
        TITLE: "General Report",
        PDF: "PDF",
        CSV: "CSV",
        RTF: "RTF",
        XLS: "XLS",
    },
}
